import { useTranslation } from 'react-i18next'
import { FlaskConical, RotateCcw, Trash2 } from 'lucide-react'
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from '../../ui/dropdown-menu'
import { WithTooltip } from '../../ui/tooltip'
import { dispatchAppEvent } from '../../../lib/events'
import { useTestDataActions } from '../../../lib/testData'
import './HelpMenuButton.scss'

/**
 * **Hilfe** (#323): das ? unten in der schmalen Leiste, über dem Profilbild (Svens Wunsch im Prototyp). Gibt
 * es auch im Web, wo das App-Menü „Hilfe“ fehlt.
 *
 * - „Einführung neu starten“ → `intro-restart`, `MainLayout` legt an, was fehlt.
 * - „Testdaten anlegen / entfernen …“ → derselbe Weg wie das App-Menü (`testdata-request`), mit Rückfrage.
 *
 * @example
 * <HelpMenuButton />
 */
export function HelpMenuButton() {
  const { t } = useTranslation()
  const testData = useTestDataActions()

  return (
    <DropdownMenu>
      <WithTooltip content={t('intro.helpMenu.label')} side="right">
        <DropdownMenuTrigger asChild>
          <button type="button" className="help-menu-button" aria-label={t('intro.helpMenu.label')}>
            <span className="help-menu-button__circle" aria-hidden="true">?</span>
          </button>
        </DropdownMenuTrigger>
      </WithTooltip>
      <DropdownMenuContent side="right" align="end" sideOffset={4} onCloseAutoFocus={event => event.preventDefault()}>
        <DropdownMenuItem onSelect={() => dispatchAppEvent('intro-restart')}>
          <RotateCcw size={16} className="context-menu-content__item-icon" />
          <span>{t('intro.helpMenu.restart')}</span>
        </DropdownMenuItem>
        {testData && (
          <>
            <DropdownMenuSeparator />
            <DropdownMenuItem onSelect={() => dispatchAppEvent('testdata-request', { action: 'create' })}>
              <FlaskConical size={16} className="context-menu-content__item-icon" />
              <span>{t('testData.create')} …</span>
            </DropdownMenuItem>
            <DropdownMenuItem onSelect={() => dispatchAppEvent('testdata-request', { action: 'remove' })}>
              <Trash2 size={16} className="context-menu-content__item-icon" />
              <span>{t('testData.remove')} …</span>
            </DropdownMenuItem>
          </>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
